import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgEyeClosedIconSecondary from './svgs/EyeClosedIconSecondary.js';
import SvgEyeClosedIcon from './svgs/EyeClosedIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var eyeClosedIcon = (props => useIcon(SvgEyeClosedIcon, SvgEyeClosedIconSecondary, props));

export { eyeClosedIcon as default };
